import camelCase from 'camelcase';

export const trackingData = {
  dropdownToggle: {
    eventType: 'track',
    eventContainer: 'globalNavProfile',
    eventComponent: 'DropdownMenu',
    event: 'clicked',
    magnoliaComponentId: null
  },
  siteLink: {
    eventType: 'track',
    eventContainer: 'globalNavProfile',
    eventComponent: 'SiteLink',
    event: 'clicked',
    magnoliaComponentId: null,
    productKey: null,
    atlOrigin: null
  }
};

export const parseProductKey = (product: string) => {
  return camelCase(product);
};

export const getParameterByName = (name: string, url: string) => {
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
